import { render, staticRenderFns } from "./charge-wait-pay.vue?vue&type=template&id=84842b44&scoped=true&"
import script from "./charge-wait-pay.vue?vue&type=script&lang=js&"
export * from "./charge-wait-pay.vue?vue&type=script&lang=js&"
import style0 from "./charge-wait-pay.vue?vue&type=style&index=0&id=84842b44&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84842b44",
  null
  
)

export default component.exports